import { ISoftData } from "@/common/interface";
import { Rank } from "@/components/common/Rank";
import { IIndexState } from "@/store/index";
import React from "react";
import { connect } from "react-redux";

interface IProps {
  data: ISoftData[];
}

const HotRank = ({ data }: IProps) => {
  return (
    <Rank
      className="hot-rank"
      title="热门排行榜"
      data={data.slice(0, 8)}
      loading={!(data && data.length)}
      position="maintop"
    />
  );
};

const mapStateToProps = ({ indexData: { top } }: IIndexState) => ({
  data: top,
});

export default connect(mapStateToProps)(HotRank);
